import * as React from 'react';
import * as qs from 'qs';

import { Member } from 'common/api/models/Member';
import { Progress } from 'common/components/Progress';
import { EntityActions, EntityType } from 'common/entity';
import { History, Location } from 'history';
import { AppState } from 'common/models/AppState';
import { Page } from 'common/components/layout/Page/Page';
import { Loading } from 'common/components/Loading';
import { toApiError } from 'common/utils/api';
import { MediaApi } from 'common/api/resources/MediaApi';

export interface UploadProps {
  appState: AppState;
  entityActions: EntityActions;
  history: History;
  location: Location;
}

export interface UploadState {
  progress: number;
  filterType: string;
  successMessage: string;
  selectedFiles?: FileList;
  isUploading: boolean;
  isLoading: boolean;
  inputKey: string;
  member?: Member;
  error?: string;
}

export class Upload extends React.Component<UploadProps, UploadState> {
  state: UploadState = {
    isUploading: false,
    isLoading: true,
    progress: -1,
    selectedFiles: undefined,
    inputKey: Math.random().toString(36),
    filterType: '',
    successMessage: '',
  };

  constructor(props: any) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick = () => {
    if (this.state.filterType === '') {
      this.setState({
        error: 'Please select product type.',
      });
      return;
    }

    if (this.state.selectedFiles === undefined) {
      this.setState({
        error: 'Please select file for upload.',
      });
      return;
    }

    let formData = new FormData();
    let fileName = '';
    Array.from(this.state.selectedFiles!).forEach(file => {
      formData.append('files', file);
      fileName = file.name;
    });

    this.setState({ error: undefined, progress: 0 });
    MediaApi.uploadExcel(
      formData,
      {
        producttype: this.state.filterType,
        orgid: this.state.member!.id!,
        filename: fileName,
      },
      {
        onUploadProgress: (p: any) => {
          this.setState({ successMessage: '', isUploading: true, progress: Math.round((p.loaded * 100) / p.total) });
        },
      }
    )
      .then(res => {
        this.setState({
          selectedFiles: undefined,
          error: undefined,
          progress: -1,
          isUploading: false,
          inputKey: Math.random().toString(36),
          filterType: '',
          successMessage:
            'File upload is complete. Once the import is completed, an email will be sent to your inbox on file.  Thank you.',
        });
      })
      .catch(error => {
        this.setState({
          error: toApiError(error),
          isUploading: false,
          progress: -1,
          successMessage: '',
        });
      });
  };

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) {
      return;
    }

    this.setState({
      selectedFiles: e.target.files,
      successMessage: '',
      error: undefined,
      progress: -1,
    });
  };

  handleChangeProduct = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ filterType: e.currentTarget.value });
  };

  componentDidMount() {
    const params = qs.parse(this.props.location.search.substring(1));
    if (params.memberId) {
      this.props.entityActions.fetch<Member>(EntityType.MEMBER, params.memberId).then(
        member => {
          this.setState({ member, isLoading: false });
        },
        err => {
          this.setState({ error: toApiError(err) });
        }
      );
    } else {
      this.setState({ isLoading: false });
    }
  }

  render() {
    const member = this.state.member;
    let memberName = '';
    let memberNumber = 0;

    if (member && member.name) {
      memberName = member!.name!;
    }
    if (member && member.number) {
      memberNumber = member!.number!;
    }

    const { isUploading, isLoading, error, successMessage } = this.state;
    const errorStyle = {
      color: 'red',
    };
    if (isLoading) {
      return (
        <Page title="Upload Eligibility CSV" breadcrumbs={[{ label: memberName, to: '/orgs/' + memberNumber }]}>
          <Loading />
        </Page>
      );
    }

    return (
      <Page title="Upload Eligibility CSV" breadcrumbs={[{ label: memberName, to: '/orgs/' + memberNumber }]}>
        <div className="row">
          <div className="col">
            <label>Product Type</label>
            <select
              className="form-control"
              style={{ marginLeft: 10, width: 300, minWidth: 300, display: 'inline-block' }}
              value={this.state.filterType}
              onChange={this.handleChangeProduct}
            >
              <option value="">-- Select --</option>
              <option value="BADGE">BADGE</option>
              <option value="CERT_NEW">CERTIFICATION</option>
            </select>
          </div>
        </div>
        <div className="row" style={{ marginTop: 20 }}>
          <div className="col">
            <input type="file" onChange={this.handleChange} key={this.state.inputKey} />
          </div>
        </div>
        <div className="row" style={{ marginTop: 20 }}>
          <div className="col">
            <input type="button" onClick={this.handleOnClick} value="Upload" disabled={this.state.isUploading} />
          </div>
        </div>

        {error && (
          <div className="row" style={{ marginTop: 20 }}>
            <div className="col">
              <div style={errorStyle}>{error}</div>
            </div>
          </div>
        )}

        {successMessage !== '' && (
          <div className="row" style={{ marginTop: 20 }}>
            <div className="col">
              <div style={{ color: 'green' }}>{successMessage}</div>
            </div>
          </div>
        )}

        {isUploading && (
          <div className="row" style={{ marginTop: 20 }}>
            <div className="col">
              <div style={{ maxWidth: '80%' }} className="xs-mx-auto">
                {this.state.progress > -1 && <Progress percentage={this.state.progress} />}
              </div>
            </div>
          </div>
        )}
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Upload/Upload.tsx